import { SearchLinkedinWrapper } from './styles';
import { FC, useEffect, useState } from 'react';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import { CircularProgress, Typography } from '@mui/material';
import Profile from './Profile';

import {
  CloseButton,
  MainPrimaryButton,
} from 'crono-fe-common/components/CronoButton';
import { useAnalytics } from 'context/analytics';
import CloseMIcon from 'crono-fe-common/icons/Icon-Close';
import { colors } from 'crono-fe-common/theme';
import { useLinkedinSearchLeads } from 'crono-fe-common/hooks/crono-extension/gateway';
import {
  CronoGatewayLinkedinSearchLeadsAction,
  LinkedinProfile,
} from 'crono-fe-common/types/crono-extension/linkedin';
import { openLinkedinAccount } from 'utils/businessLogic';
import LinkedinUrlUtils from 'crono-fe-common/utils/LinkedinUrlUtils';
import { ActionPreconditionProps } from './types';

const SearchLinkedin: FC<ActionPreconditionProps> = ({
  account,
  setOpenModal: setOpen,
  prospect,
  callOnSuccess,
}) => {
  const [leads, setLeads] = useState<LinkedinProfile[]>([]);
  const analytics = useAnalytics();

  const {
    call: searchLeads,
    result: searchLeadsResult,
    isLoading: isSearchLeadLoading,
  } = useLinkedinSearchLeads();

  useEffect(() => {
    if (searchLeadsResult?.profiles) {
      setLeads(searchLeadsResult.profiles);
    }
  }, [searchLeadsResult]);

  useEffect(() => {
    if (!searchLeadsResult) {
      const companyPublicId = LinkedinUrlUtils.getIdFromLinkedinCompanyUrl(
        account.linkedin,
      )[0];

      if (analytics) {
        analytics.track('search-linkedin', {});
      }
      const searchLeadsParams: CronoGatewayLinkedinSearchLeadsAction['params'] =
        {
          companyName: account?.name,
          userFirstName: prospect?.firstName,
          userLastName: prospect?.lastName,
          title: null,
        };
      if (companyPublicId) {
        searchLeadsParams.companyPublicId = companyPublicId;
      }
      searchLeads(searchLeadsParams);
    }
  }, [searchLeadsResult, account]);
  return (
    <SearchLinkedinWrapper>
      <div
        style={{
          display: 'flex',
          flex: 1,
          overflow: 'hidden',
        }}
      >
        <FlexDiv
          direction="column"
          alignItems="end"
          style={{ rowGap: 20, overflow: 'hidden', flex: 1 }}
        >
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              fontSize={20}
              fontWeight={700}
              style={{ alignSelf: 'flex-start' }}
            >
              Search linkedin profile
            </Typography>
            <CloseButton size="large" onClick={() => setOpen(false)}>
              <CloseMIcon color={colors.grey11} />
            </CloseButton>
          </div>

          <div className="modal-body">
            {isSearchLeadLoading ? (
              <FlexDiv className="loading">
                <CircularProgress />
              </FlexDiv>
            ) : (
              <FlexDiv
                className="modal-content"
                direction="column"
                justifyContent="center"
                height="fit-content"
              >
                {searchLeadsResult && prospect && leads.length > 0 ? (
                  leads
                    .filter(
                      (l) =>
                        l.firstName !== '' &&
                        l.lastName !== '' &&
                        l.profileId !== 'UNKNOWN',
                    )
                    .map((lead) => (
                      <Profile
                        key={lead.profileId}
                        profile={lead}
                        prospect={prospect}
                        setOpen={setOpen}
                        callOnSuccess={callOnSuccess}
                      />
                    ))
                ) : (
                  <FlexDiv
                    className="modal-content"
                    direction="column"
                    justifyContent="center"
                  >
                    <h3>We couldn’t find a LinkedIn profile</h3>
                    {(!account?.linkedin || account.linkedin === '') && (
                      <FlexDiv>
                        <p>
                          Add a LinkedIn company URL to improve search results
                        </p>
                      </FlexDiv>
                    )}
                  </FlexDiv>
                )}
              </FlexDiv>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              width: '100%',
            }}
          >
            <MainPrimaryButton
              className="modal-button"
              onClick={() => openLinkedinAccount(account)}
            >
              Go To LinkedIn
            </MainPrimaryButton>
          </div>
        </FlexDiv>
      </div>
    </SearchLinkedinWrapper>
  );
};

export default SearchLinkedin;
